import { type AppState, type EntityRef } from "@client/types";
import { connect } from "react-redux";
import { clearFailureReason } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = EntityRef & {};
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      isVisible: localState.failureReason === "Inventory"
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onClose: () => dispatch(clearFailureReason(props))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
